module.exports = __webpack_public_path__ + "img/icon_tbbj.5fb1e930.png";